module.exports = {
	events: {
		userAction: {
			type: 'click',
			selector: 'div.button',
			action: function(event){
				var self = event.data.component;
				var $target = $(event.target);
				var $realTarget;

				if($target.length > 0 && ($realTarget = $target.closest('.button')).length > 0){
					if($realTarget.hasClass('logout')){
						self.performAction(
							self.prepareAction('logout')
						);
					} else if($realTarget.hasClass('add')){
						self.performAndStoreAction(
							'showInsert_literature_inEffect',
							self.prepareAction('showInsert_literature')
						);
					} else if($realTarget.hasClass('login')){
						self.performAndStoreAction(
							undefined,
							self.prepareAction('showLoginForm', undefined, { loginForm: { forcePageRefresh: true }})
						);
					} else if($realTarget.hasClass('refresh')){
						self.triggerFind('onRefresh');
					}
				}
			}
		}
	},

	hooks: {
		onDecision: function($element, options){
			var self = this;

			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
							var modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component;
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_literature')){
								modalContentComponent.submit().then(function(context){
									options.decisionComponent.hide();
								}).then(function(context){
									self.find('templates_controller_list', function(listComponent){
										listComponent.refresh();
									});
								});
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
							options.decisionComponent.hide();
							self.find('templates_controller_list', function(listComponent){
								listComponent.refresh();
							});
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		},

		showEdit_literature: function($element, options){
			var literatureID = (options || {}).literatureID;
			if(literatureID){
				this.performAndStoreAction(
					'showEdit_literature_' + literatureID,
					this.prepareAction('showEdit_literature', literatureID)
				);
			}
		},

		delete_literature: function($element, options){
			var self = this;
			var literatureID = (options || {}).literatureID;

			if(literatureID){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      __('hint.delete.really.literature.title'),
						message:    __('hint.delete.really.literature.message')
					}
				).then(function(context) {
					if (context.decision.type == 'yes') {
						self.performAction(
							self.prepareAction('delete_literature', literatureID)
						).then(function(context){
							var statusController;
							if((statusController = getComponent('statusController'))){
								statusController.addPanel('status.done.delete');
							}
							self.refresh();
						}).fail(function(error){
							console.log('error on delete', error);
							self.refresh();
						});
					}
				});
			}
		}
	}
}